import React, { useState, useEffect } from "react";
import "./ArquitecturaPlataformas.css";
import bannerImg from "../assets/images/fachada.jpg";
import carreraImg from "../assets/programa_estudios/contabilidad/contabilidad.jpg";
import pdfResolucion from "../assets/programa_estudios/contabilidad/resolucion-contabilidad.pdf";
import pdfPrograma from "../assets/programa_estudios/contabilidad/programa-contabilidad.pdf";
import { FaFilePdf, FaFacebook, FaYoutube, FaMapMarkerAlt, FaPhoneAlt, FaClock } from "react-icons/fa";

import banner1 from "../assets/programa_estudios/contabilidad/minibanner1.jpg";
import banner2 from "../assets/programa_estudios/contabilidad/minibanner2.jpg";
import banner3 from "../assets/programa_estudios/contabilidad/minibanner3.jpg";



const ArquitecturaPlataformas = () => {
  const [activeTab, setActiveTab] = useState("perfil");

  const [selectedPdf, setSelectedPdf] = useState(null);

  const abrirPDF = (pdf) => {
    setSelectedPdf(pdf);
  };

  const cerrarPDF = () => {
    setSelectedPdf(null);
  };


  return (
    <section className="carrera-detalle page-animate">
      {/*  Banner superior */}
      <div className="carrera-hero-modern" style={{ backgroundImage: `url(${bannerImg})` }}>
        <div className="carrera-hero-overlay">
          <h1 className="fw-bold text-uppercase text-white text-center">
            Programa de Estudio Contabilidad
          </h1>
          <p className="subtitulo">Para crear y administrar la empresa - ¡En solo 3 años sé un profesional de éxito, ven únete a nosotros!</p>
        </div>
      </div>

      {/*  Contenido */}
      <div className="container my-5">
        <div className="row g-4">
          {/*  Información principal */}
          <div className="col-lg-8">
            <div className="info-card p-4 shadow-sm rounded-4 bg-white">
              <h3 className="text-primary fw-bold mb-3 text-uppercase">
                TÍTULO: Profesional Técnico en CONTABILIDAD
              </h3>
              <p>
                 ¿Te apasionan los números y la organización? ¿Eres metódico, analítico y tienes
                  un gran sentido de la responsabilidad? Si tu respuesta es sí, en este programa 
                  de formación integral, adquirirás las habilidades y conocimientos necesarios 
                  para desenvolverte con éxito en el mundo de las finanzas y la gestión empresarial. 
                  Aprenderás a registrar, analizar e interpretar información financiera, elaborar 
                  estados contables, gestionar impuestos y aplicar las normas contables vigentes.
              </p>
              <p>
                 ¿De la mano de Docentes altamente calificados y experimentados en el sector contable, 
                 desarrollarás las competencias necesarias para convertirte en un profesional integral, 
                 capaz de asesorar a empresas en la toma de decisiones estratégicas, optimizar sus 
                 recursos financieros y garantizar su cumplimiento fiscal.
              </p>

              {/*  Pestañas */}
              <div className="tabs-container">
                <div className="tabs">
                  <button
                    className={activeTab === "perfil" ? "tab active" : "tab"}
                    onClick={() => setActiveTab("perfil")}
                  >
                    Perfil de Egresado
                  </button>
                  <button
                    className={activeTab === "ambito" ? "tab active" : "tab"}
                    onClick={() => setActiveTab("ambito")}
                  >
                    Ámbito Laboral
                  </button>
                  <button
                    className={activeTab === "certificaciones" ? "tab active" : "tab"}
                    onClick={() => setActiveTab("certificaciones")}
                  >
                    Certificaciones
                  </button>
                  <button
                    className={activeTab === "itinerario" ? "tab active" : "tab"}
                    onClick={() => setActiveTab("itinerario")}
                  >
                    Itinerario Formativo
                  </button>
                </div>
                <div className="tab-content mt-4">
                {activeTab === "perfil" && (
                    <div className="tab-section fade-in">
                    <h5 className="text-primary fw-bold mb-3">Perfil del Egresado</h5>
                    <p>El Egresado del Programa Profesional Técnico en Contabilidad es competente para 
                      desarrollar, supervisar y actualizar las operaciones de contabilidad y finanzas, 
                      además formula el estado de situación financiera de la organización, según política, 
                      procedimientos y normativa correspondiente.
                    </p>
                    <p>
                      Se comunica de manera efectiva, aplica 
                      las TIC en su quehacer profesional utiliza el idioma inglés en el desarrollo de 
                      sus actividades, promueve la cultura y practica deportivas, así mismo es innovador 
                      e identifica oportunidades de negocio, soluciona problemas de su entorno y aplica 
                      la ética en los espacios donde se desenvuelve, respetando la línea de autoridad 
                      en el ejercicio de su profesión.
                    </p>
                    </div>
                )}

                {activeTab === "ambito" && (
                    <div className="tab-section fade-in">
                    <h5 className="text-primary fw-bold mb-3">Ámbito Laboral</h5>
                    <p>
                        El profesional Técnico en Contabilidad podrá desempeñase en instituciones públicas 
                        y privadas en las siguientes áreas:
                    </p>
                    <div className="row">
                        <div className="col-md-6">
                        <ul className="styled-list">
                            <li>Área de Contabilidad</li>
                            <li>Área de Finanzas</li>
                            <li>Área de Auditoria</li>
                            <li>Área de Tributación</li>
                            <li>Área de Costos y Presupuesto</li>
                            <li>Área de Logística y Almacenes</li>
                            <li>Área de Recursos Huamanos</li>
                            <li>Área de Proyectos de Inversión</li>
                        </ul>
                        </div>
                        <div className="col-md-6">
                        <ul className="styled-list">
                            <li>Área de Tesorería</li>
                            <li>Área de Analísis Financiero</li>
                        </ul>
                        </div>
                    </div>
                    </div>
                )}

                {activeTab === "certificaciones" && (
                    <div className="tab-section fade-in">
                    <h5 className="text-primary fw-bold mb-3">Certificaciones</h5>
                    <p>
                        Al culminar los 3 años de estudios, el estudiante obtiene el título a nombre de la Nación:
                    </p>
                    <p className="fw-bold text-primary">
                        Profesional Técnico en “CONTABILIDAD”
                    </p>
                    <p>Además, se otorgan 3 certificaciones modulares:</p>
                    <ul className="styled-list">
                        <li>Desarrollo de Operaciones Contables y Financieras</li>
                        <li>Supervisión de Operaciones Contables y Financieras</li>
                        <li>Formulación y Análisis Contable y Financiero</li>
                    </ul>
                    </div>
                )}

                {activeTab === "itinerario" && (
                    <div className="tab-section fade-in">
                      <h5 className="text-primary fw-bold mb-4">Itinerario Formativo</h5>

                      <div className="itinerario-periodo">
                        <h6>Primer Periodo <span>(7 Unidades Didácticas)</span></h6>
                        <ul className="styled-list">
                          <li>Administración Empresarial</li>
                          <li>Documentación Comercial y Contable</li>
                          <li>Plan Contable</li>
                          <li>Contabilidad General</li>
                          <li>Comunicación Oral</li>
                          <li>Aplicaciones en Internet</li>
                          <li>Educación Física y Deportiva</li>
                        </ul>
                      </div>

                      <div className="itinerario-periodo">
                        <h6>Segundo Periodo <span>(6 Unidades Didácticas)</span></h6>
                        <ul className="styled-list">
                          <li>Legislación Laboral</li>
                          <li>Libros y Registros Contables</li>
                          <li>Legislación Tributaria</li>
                          <li>Fundamentos de Costos</li>
                          <li>Interpretación y Producción de Textos</li>
                          <li>Ofimática</li>
                        </ul>
                      </div>

                      <div className="itinerario-periodo">
                        <h6>Tercer Periodo <span>(6 Unidades Didácticas)</span></h6>
                        <ul className="styled-list">
                          <li>Técnica Presupuestal</li>
                          <li>Aplicativos Informáticos</li>
                          <li>Procesos Contables en el Sector Público</li>
                          <li>Contabilidad de Costos</li>
                          <li>Inglés para la Comunicación Oral</li>
                          <li>Estrategias para la Resolución de Problemas</li>
                        </ul>
                      </div>

                      <div className="itinerario-periodo">
                        <h6>Cuarto Periodo <span>(5 Unidades Didácticas)</span></h6>
                        <ul className="styled-list">
                          <li>Contabilidad de Sociedades</li>
                          <li>Sistemas y Aplicaciones Contables</li>
                          <li>Contabilidad Gubernamental</li>
                          <li>Comportamiento Ético</li>
                          <li>Comprensión y Redacción en Inglés</li>
                        </ul>
                      </div>

                      <div className="itinerario-periodo">
                        <h6>Quinto Periodo <span>(6 Unidades Didácticas)</span></h6>
                        <ul className="styled-list">
                          <li>Normas Internacionales de Información Financiera</li>
                          <li>Formulación de Estados Financieros</li>
                          <li>Fundamentos de Auditoría</li>
                          <li>Finanzas Privadas</li>
                          <li>Contabilidad de Entidades Financieras</li>
                          <li>Fundamentos de Innovación Tecnológica</li>
                        </ul>
                      </div>

                      <div className="itinerario-periodo">
                        <h6>Sexto Periodo <span>(7 Unidades Didácticas)</span></h6>
                        <ul className="styled-list">
                          <li>Análisis de los Estados Financieros</li>
                          <li>Finanzas Públicas</li>
                          <li>Auditoría Aplicada</li>
                          <li>Administración y Evaluación de Proyectos</li>
                          <li>Cálculo Financiero</li>
                          <li>Innovación Tecnológica</li>
                          <li>Plan de Negocios</li>
                        </ul>
                      </div>
                    </div>
                  )}

                </div>

              </div>
            </div>
          </div>

          {/*  Panel lateral */}
          <div className="col-lg-4">
            <div className="sidebar-card p-4 rounded-4 shadow-sm text-center bg-white">
              <img src={carreraImg} alt="Arquitectura de Plataformas" className="img-fluid rounded-3 mb-3" />
              <button onClick={() => abrirPDF(pdfResolucion)} className="btn btn-download w-100 mb-3">
                
            <FaFilePdf className="me-2" /> Resolución de Autorización
            </button>

            <button onClick={() => abrirPDF(pdfPrograma)} className="btn btn-download w-100 mb-3">
            <FaFilePdf className="me-2" /> Programa de Estudios
            </button>

              <a
                href="https://drive.google.com/drive/folders/1_-SaBpB4T8sA3Rt8UIq0Si5M0-7ZXYed"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-outline-primary w-100"
              >
                Ver Sílabos
              </a>

              <div className="mt-4 text-start contacto-box">
                <h6 className="text-primary fw-bold mb-2">INFORMACIÓN DE CONTACTO</h6>
                <p className="mb-2"><FaMapMarkerAlt className="me-2 text-primary" />Av. José Olaya Nº 120, San Gabriel, V.M.T</p>
                <p className="mb-2"><FaPhoneAlt className="me-2 text-primary" />(01) 500 6177</p>
                 <p className="horario-lineas">
                    <FaClock className="me-2 text-primary" />
                    Diurno: 8:00 a.m. - 1:00 p.m. <br />
                    <span>Nocturno: 5:30 p.m. - 10:00 p.m.</span>
                </p>

                <div className="social-links mt-3">
                  <a href="https://facebook.com" target="_blank" rel="noreferrer">
                    <FaFacebook />
                  </a>
                  <a href="https://youtube.com" target="_blank" rel="noreferrer">
                    <FaYoutube />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

         {/* 🔹 Banner inferior con 3 fotos */}
        <div className="banner-slider">
        <div className="slide-track">
          <img src={banner1} alt="Campus 1" />
          <img src={banner2} alt="Campus 2" />
          <img src={banner3} alt="Campus 3" />
          {/* Repite las mismas imágenes para el loop suave */}
          <img src={banner1} alt="Campus 1 duplicado" />
          <img src={banner2} alt="Campus 2 duplicado" />
          <img src={banner3} alt="Campus 3 duplicado" />
        </div>
      </div>

      
      </div>

      {/*  Modal PDF */}
     {selectedPdf && (
        <div className="pdf-modal" onClick={cerrarPDF}>
          <div
            className="pdf-modal-content-wide"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="close-btn" onClick={cerrarPDF}>
              ✕
            </button>
            <iframe
              src={`${selectedPdf}#view=FitH`}
              title="Vista PDF"
              className="pdf-full-view-wide"
            ></iframe>
          </div>
        </div>
      )}
    </section>
  );
};

export default ArquitecturaPlataformas;
